export default __webpack_public_path__ + "static/media/logo_notredame_light.3d86d9ba.png";